import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=78facf5c&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=78facf5c&prod&lang=scss&scoped=true"
import style1 from "./Auth.vue?vue&type=style&index=1&id=78facf5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78facf5c",
  null
  
)

export default component.exports